var a={px:"S",py:"XS",radius:"S"};export{a as default};
